// extracted by mini-css-extract-plugin
export var csatScore = "_l9-5";
export var header = "_l9-1";
export var panelWrapper = "_l9-2";
export var postPreview = "_l9-3";
export var rightContent = "_l9-0";
export var wrappingText = "_l9-4";